<template>
    <div class="vx-row">
        <div class="vx-col md:w-4/4 w-full mb-base">
            <vx-card title="Device Info">
                <div class="w-full flex flex-wrap">
                    <div class="w-full">

                        <div>
                           <!-- <vs-divider>
                                <span class="uppercase">Payment channel default properties</span>
                            </vs-divider>-->

                            <div class="w-full flex flex-wrap">
                                <div class="w-4/5 flex flex-no-wrap">
                                    <div class="w-1/4 p-4 pt-6">Merchant Name</div>
                                    <div class="w-3/4 p-4">
                                        {{data_request_detail.device_request.merchants.brand_name}}
                                    </div>
                                </div>
                                <div class="w-4/5 flex flex-no-wrap">
                                    <div class="w-1/4 p-4 pt-6">Merchant Code</div>
                                    <div class="w-3/4 p-4">
                                        {{data_request_detail.device_request.merchants.code}}
                                    </div>
                                </div>
                                <div class="w-4/5 flex flex-no-wrap">
                                    <div class="w-1/4 p-4 pt-6">Device Type</div>
                                    <div class="w-3/4 p-4">
                                        {{data_request_detail.device_request.device_type.name}}
                                    </div>
                                </div>
                                <div class="w-4/5 flex flex-no-wrap">
                                    <div class="w-1/4 p-4 pt-6">Device Code</div>
                                    <div class="w-3/4 p-4">
                                       {{data_request_detail.code}}
                                    </div>
                                </div>
                                <div class="w-4/5 flex flex-no-wrap">
                                    <div class="w-1/4 p-4 pt-6">Device Name</div>
                                    <div class="w-3/4 p-4">
                                        <vs-input
                                                id="txt-device-name"
                                                type="text"
                                                v-model="data_request_detail.name"
                                                placeholder="Device Name"
                                                class="w-full mb-4 no-icon-border"
                                        />
                                    </div>
                                </div>
                                <div class="w-4/5 flex flex-no-wrap">
                                    <div class="w-1/4 p-4 pt-6">Description</div>
                                    <div class="w-3/4 p-4">
                                        <vs-input
                                                id="txt-description"
                                                type="text"
                                                v-model="data_request_detail.notes"
                                                placeholder="Description"
                                                class="w-full mb-4 no-icon-border"
                                        />
                                    </div>
                                </div>
                                <div class="w-4/5 flex flex-no-wrap">
                                    <div class="w-1/4 p-4 pt-6">Device Configuration</div>
                                    <div class="w-3/4 p-4">
                                        <vs-textarea
                                                id="txt-device-config"
                                                type="text"
                                                v-model="device_config"
                                                placeholder="Device Configuration"
                                                class="w-full mb-4 no-icon-border"
                                        />
                                    </div>
                                </div>
                                <div class="w-4/5 flex flex-no-wrap">
                                    <div class="w-1/4 p-4 pt-6">Payment Channel</div>
                                    <div class="w-3/4 p-4">
                                        <v-select id="cbo-payment-channel" v-model="selected_channel" placeholder="Select payment channel"
                                                  :options="payment_channel_list"></v-select>
                                    </div>
                                </div>
                                <div class="w-1/5 p-4">
                                    <vs-button
                                            id="btn-add-payment-channel"
                                            class="mr-3 w-full"
                                            icon-pack="feather"
                                            icon="icon-plus"
                                            @click="addPaymentChannel"
                                    >Add Channel
                                    </vs-button>
                                </div>

                                <span class="w-full mb-6"/>
                                <vx-card
                                        class="w-full mb-6"
                                        :title="data.key"
                                        collapse-action
                                        remove-card-action
                                        @remove="deleteConfig(index)"
                                        :key="index"
                                        v-for="(data, index) in data_config"
                                >
                                    <div class="w-full flex flex-no-wrap">
                                        <div class="w-4/5 p-4">
                                            <vs-input  v-bind:id="'txt-channel-'+index+'-add-property'" class="w-full" placeholder="Name" v-model="temp_prop[index]"/>
                                        </div>
                                        <div class="w-1/5 p-4">
                                            <vs-button
                                                    v-bind:id="'btn-channel-'+index+'-add-property'"
                                                    class="mr-3 mb-2"
                                                    icon-pack="feather"
                                                    icon="icon-plus"
                                                    @click="addProp(index)"
                                            >Add Property
                                            </vs-button>
                                        </div>
                                    </div>
                                    <div class="w-full flex flex-wrap" v-if="data_config[index].value.length > 0">
                                        <div class="w-4/5 flex flex-no-wrap">
                                            <div class="w-2/4 px-4 py-0"><h3>Payment Channel Added</h3></div>
                                            <div class="w-2/4 px-4 py-0 flex flex-wrap">&nbsp;</div>
                                        </div>
                                        <div class="w-4/5 flex flex-no-wrap">
                                            <div class="w-2/4 px-4 py-0"></div>
                                            <div class="w-2/4 px-4 py-0 flex flex-wrap">&nbsp;</div>
                                        </div>
                                    </div>
                                    <div
                                            class="w-full flex flex-wrap"
                                            :key="ind"
                                            v-for="(data, ind) in data_config[index].value"
                                    >
                                        <div class="w-4/5 p-4 flex flex-wrap">
                                            <div class="w-full px-4 py-0 flex flex-wrap">
                                                <span class="w-2/5">{{data.key}}</span>
                                                <span class="w-2/5">
                                                     <vs-input v-bind:id="'btn-channel-'+index+'-property-'+ind" class="w-full" placeholder="Value" v-model="data.value" />
                                                </span>
                                                <span class="w-1/5 text-right">
                                                  <feather-icon
                                                          icon="Trash2Icon"
                                                          svgClasses="h-5 w-5"
                                                          class="cursor-hand"
                                                          @click="deleteProp(index,ind)"
                                                  />
                                                </span>
                                            </div>
                                            <div class="w-full" v-if="ind!=data_config[index].value.length-1">
                                                <vs-divider/>
                                            </div>
                                        </div>
                                    </div>
                                </vx-card>
                            </div>
                        </div>
                    </div>
                </div>
            </vx-card>
        </div>
        <vx-card>
            <div class="w-full text-right">
                <vs-button id="btn-cancel" type="border" @click="backPage">Cancel</vs-button>
                <vs-button id="btn-submit" class="ml-4" @click.prevent="submitForm">Submit</vs-button>
            </div>
        </vx-card>
    </div>
</template>

<script>
    import AxiosCall from "@/global/AxiosCall";
    import {url} from "@/configs/apiUrl";
    import vSelect from 'vue-select'

    export default {
        name: "DeviceConfig",
        components: {
            'v-select': vSelect,
        },
        data() {
            return {
                data_config:[],
                device_config:"",
                temp_prop: [],
                data_request_detail:{name:"", code:"", notes:"", device_request:{merchants:{brand_name:"", code:""}, device_type:{name:""}}},
                payment_channel_list:[],
                selected_channel:"",
                colorAlert:'danger'
            };
        },
        methods: {
            backPage() {
                this.$router.push({name: 'DeviceReport'})
            },
            addProp(index) {
                if (this.temp_prop.length > 0){
                    if (this.temp_prop[index] !== ""){
                        if (!this.data_config[index].value.some(el => el.key === this.temp_prop[index])){

                            this.data_config[index].value.push({key:this.temp_prop[index], value:""});
                            this.temp_prop[index] = "";
                        }else{
                            this.warning("Warning", "Property name already exist!");
                        }
                    }else{
                        this.warning("Warning", "Please input name!");
                    }
                }else{
                    this.warning("Warning", "Please input name!");
                }
            },
            addPaymentChannel(){
                if (this.selected_channel !== null && this.selected_channel !== "") {
                    let checkDataChannelIsExist = this.data_config.filter(obj => {
                        return obj.key === this.selected_channel.code;
                    });

                    if (checkDataChannelIsExist.length > 0) {
                        this.$vs.notify({
                            title: "Payment Channel Config",
                            text: "Payment Channel already added",
                            color: "danger",
                            position: "top-right"
                        });
                    } else {
                        let channelObj = this.payment_channel_list.filter(obj => {
                            return obj.id === this.selected_channel.id;
                        });
                        let obj = []
                        if (channelObj[0].payment_methods.code == "chipbase") {
                            if (channelObj[0].general_configs.length !== 0) {
                                for (let i in channelObj[0].general_configs[0].value.data_header){
                                    let header = channelObj[0].general_configs[0].value.data_header[i]
                                    let value = channelObj[0].general_configs[0].value.data_value[0][header]
                                    obj.push({key:header, value:value})
                                }
                            } else {
                                obj.push({"key":"channel id", value:this.selected_channel.id})
                            }
                        }else {
                            obj.push({"key":"channel id", value:this.selected_channel.id})
                        }
                        this.data_config.push({key:channelObj[0].code, value:obj})
                    }
                    this.selected_channel = "";
                } else {
                    this.$vs.notify({
                        title: "Payment Channel not selected",
                        text: "Please select a payment channel",
                        color: "warning",
                        position: "top-right"
                    });
                }
            },
            deleteConfig(index){
                this.data_config.splice(index, 1)
            },
            deleteProp(indexIss, idxProp) {
                this.data_config[indexIss].value.splice(idxProp, 1);
            },
            warning(title, text) {
                this.$vs.notify({
                    title: title,
                    text: text,
                    color: "warning",
                    position: "top-right"
                });
            },
            danger(text) {
                this.$vs.notify({
                    title: "Failed",
                    text: text,
                    color: "danger",
                    position: "top-right"
                });
            },
            openLoading() {
                this.$vs.loading({
                    type: "radius"
                });
            },
            closeLoading() {
                this.$vs.loading.close();
            },
            submitForm(e) {
                e.preventDefault();
                this.$vs.dialog({
                    type:'confirm',
                    color: this.colorAlert,
                    title: `Confirm`,
                    text: 'When you change the data it will be dangerous and can be impact in the settlement process',
                    accept: () => {
                        // this.openLoading();
                        let payload =  this.data_request_detail

                        let compose_data_config = {}
                        for (let i in this.data_config){
                            let key = this.data_config[i].key
                            compose_data_config[key] = {}
                            for (let data of this.data_config[i].value){
                                compose_data_config[key][data.key] = data.value
                            }
                        }
                        payload.config.data = compose_data_config
                        payload.config.device_config = this.device_config

                        AxiosCall.Put(url.svd.device_request_detail.update ,payload).then(response =>{
                            if (response.code === 200){
                                this.$store.dispatch('createAuditTrail', {
                                    user_id:    JSON.parse(localStorage.getItem('userInfo')).id,
                                    session_id: parseInt(localStorage.getItem('sessID')),
                                    user_name:  JSON.parse(localStorage.getItem('userInfo')).displayName,
                                    menu:      "Device Report",
                                    activity: "Device Configuration",
                                    data_before: this.$store.state.current_device_config,
                                    data_after: payload,
                                })
                                this.closeLoading()
                                this.$vs.notify({
                                    title: "Success",
                                    text: "Configuration updated!",
                                    color: "success",
                                    position: "top-right"
                                });
                                this.$router.push({name:"DeviceReport"})
                            }
                        }).catch(e =>{
                            e
                            this.closeLoading()
                            this.danger('Failed update configuration!')
                        })
                    }
                })

            }
        },
        beforeMount() {
            AxiosCall.Get(url.svd.payment_channel.list_selection).then(resp => {
                for (let data of resp.data){
                    data.label = data.name
                    this.payment_channel_list.push(data)
                }
            });
            if (this.$route.query.id !== undefined) {
                AxiosCall.Get(url.svd.device_request.detailById + "/" + this.$route.query.id).then(response => {
                    this.$store.commit("UPDATE_CURRENT_DEVICE_CONFIG_DATA", response.data[0])
                })
                .catch(e => {
                    e
                })
            }
        },
        mounted() {
            if (this.$route.query.id !== undefined) {
                AxiosCall.Get(url.svd.device_request.detailById + "/" + this.$route.query.id).then(response => {
                    this.data_request_detail = response.data[0]
                    this.device_config = response.data[0].config.device_config
                    let data_config = response.data[0].config.data
                    for (let i in data_config){
                        let obj = []

                        let result = this.payment_channel_list.find(obj =>{
                            return obj.code === i
                        })

                        if (result !== undefined){
                            data_config[i]["channel id"] = result.id
                        }

                        for (let j in data_config[i]){
                            let value =data_config[i][j]
                            obj.push({key:j, value:value})
                        }
                        this.data_config.push({key:i,value:obj})
                    }

                }).catch(e => {
                    e
                })
            }

        }
    }
</script>

<style scoped>

</style>